/**
 *  ----  引用axios项目 ----
 *  @auth
 */
import axios, { AxiosInstance, AxiosError, AxiosResponse, AxiosRequestConfig } from 'axios'
import { useUserStore } from '@/stores'
import { messageError, messageWarning } from '@xr-util/xr-ui'
import domMessage from './messageOnce.js'
import { useRouter } from 'vue-router'
// import Mock from 'mockjs';

const router = useRouter()
const TIMEOUT = 60
const messageOnce = new domMessage()
export type ResWrap<T> = {
  code: string
  message: string
  data: T
}

export interface IdRequestParam {
  /**
   * 主键ID
   */
  id?: string
}
export interface PageResponse<T> {
  /**
   * 页数
   */
  pageNo?: number

  /**
   * 每页条数
   */
  pageSize?: number

  /**
   * 总条数
   */
  total: number

  /**
   * 当前页数据列表
   */
  dataList?: T[]
}
const isMessage = ['/api/msg', '/api/session']

const gateway = import.meta.env.VITE_GATEWAY
const service: AxiosInstance = axios.create({
  baseURL: gateway,
  timeout: TIMEOUT * 1000
  // timeout: 1
})

// let loadingInstance: any = null

const errorCodeList = [
  {
    code: '1004',
    name: '当前token失效，可能是编辑过员工信息，请重新登录'
  }
]

service.interceptors.request.use(
  (config: any) => {
    let la = ''
    if (useUserStore().locale && useUserStore().locale.indexOf('zh') > -1) {
      la = 'zh-CN'
    } else {
      la = useUserStore().locale || window.navigator.language
    }
    config.headers['Accept-Language'] = la
    return config
  },
  (error: AxiosError) => {
    console.log(error)
    return Promise.reject()
  }
)

service.interceptors.response.use(
  (response: AxiosResponse) => {
    // loadingInstance.close()
    if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
      // 如果是文件流直接返回
      return response
    }
    if (response && response.status === 200) {
      // 接口请求错误
      if (response.data.code != '0') {
        if (response.data.code && response.data.code == '1004') {
          // messageWarning('当前登录信息失效，请重新登录')
          messageOnce.warning({
            message: '当前登录信息失效，请重新登录'
          })
          useUserStore().loginOut()
          window.history.replaceState(null, '', '/login')
          return
        }
        // messageError(response.data.msg ? response.data.msg : '接口请求错误')
        messageOnce.error({
          message: response.data?.msg ? response.data?.msg : '接口请求错误'
        })
      }
      return response.data
    } else {
      // messageError(response.data?.msg ? response.data?.msg : '接口请求错误')
      messageOnce.error({
        message: response.data?.msg ? response.data?.msg : '接口请求错误'
      })
      Promise.reject()
    }
  },
  (error: AxiosError) => {
    let errorData: any = error.response?.data
    if (errorData?.code != '0') {
      if (errorData && errorData.code == '1004') {
        // messageWarning('当前登录信息失效，请重新登录')
        messageOnce.warning({
          message: '当前登录信息失效，请重新登录'
        })
        useUserStore().loginOut()
        window.history.replaceState(null, '', '/login')
        return
      }
      // 是否请求超时
      if (error.code == 'ECONNABORTED') {
        // messageError('请求超时，请联系运维优化')
        messageOnce.error({
          message: '请求超时，请联系运维优化'
        })
        return
      }
      let url = error.request?.responseURL
      if (!url.includes('msg/translation/oneById')) {
        // messageError(errorData?.msg ? errorData?.msg : '接口请求错误')
        messageOnce.error({
          message: errorData?.msg ? errorData?.msg : '接口请求错误'
        })
      }
    }
    return Promise.reject()
  }
)

async function get<T>(url: string): Promise<T> {
  const res = await service({
    url,
    method: 'GET'
  })

  return new Promise((resolve, _) => {
    resolve(res.data)
  })
}

async function post<T>(url: string, data: any): Promise<T> {
  const res = await service({
    url,
    data,
    method: 'POST'
  })
  return new Promise((resolve, _) => {
    resolve(res.data)
  })
}

async function postBlob<T>(url: string, data?: any): Promise<T> {
  const res = await service({
    url,
    data:data||{},
    method: 'POST',
    responseType: 'blob', // 返回文件流
    timeout: 30000
  })
  return new Promise((resolve, _) => {
    console.log(res, 'asd')
    resolve(res.data)
  })
}

export { get, post, service, postBlob }
